import React from "react";

import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button, Flex, Layout } from "antd";

import { AppShellContext, EMPTY_APP_SHELL_HEADER } from "./AppShellContext";
import { AppShellHeader } from "./AppShellHeader";
import { AppShellSidebar } from "./AppShellSidebar";

import type { AppShellHeaderContent, AppShellLayoutProps } from "./AppShell.types";

export const AppShellLayout: React.FC<AppShellLayoutProps> = ({
  banner,
  brandIcon,
  brandName,
  navigationItems,
  selectedNavigationKey,
  onNavigationSelect,
  headerTitle,
  headerCenter,
  headerActions,
  sidebarTopContent,
  sidebarFooter,
  expanded,
  defaultExpanded = false,
  onExpandedChange,
  siderWidth = 252,
  collapsedWidth = 68,
  children,
}) => {
  const [internalExpanded, setInternalExpanded] = React.useState(defaultExpanded);
  const [headerContent, setHeaderContent] =
    React.useState<AppShellHeaderContent>(EMPTY_APP_SHELL_HEADER);

  const resolvedExpanded = expanded ?? internalExpanded;
  const resolvedHeaderTitle = headerContent.title ?? headerTitle;
  const resolvedHeaderCenter = headerContent.centerContent ?? headerCenter;
  const resolvedHeaderActions = headerContent.actions ?? headerActions;

  const handleExpandedChange = (nextExpanded: boolean) => {
    if (expanded === undefined) {
      setInternalExpanded(nextExpanded);
    }

    onExpandedChange?.(nextExpanded);
  };

  const titleWithToggle = (
    <Flex align="center" gap={8}>
      <Button
        type="text"
        icon={resolvedExpanded ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
        aria-label={resolvedExpanded ? "Collapse sidebar" : "Expand sidebar"}
        onClick={() => handleExpandedChange(!resolvedExpanded)}
        style={{ color: "rgba(255, 255, 255, 0.72)" }}
      />
      {resolvedHeaderTitle}
    </Flex>
  );

  return (
    <AppShellContext.Provider value={{ headerContent, setHeaderContent }}>
      <Layout style={{ minHeight: "100vh", background: "#000000" }}>
        <AppShellSidebar
          brandIcon={brandIcon}
          brandName={brandName}
          navigationItems={navigationItems}
          selectedNavigationKey={selectedNavigationKey}
          onNavigationSelect={onNavigationSelect}
          sidebarTopContent={sidebarTopContent}
          sidebarFooter={sidebarFooter}
          expanded={resolvedExpanded}
          siderWidth={siderWidth}
          collapsedWidth={collapsedWidth}
        />

        <Layout style={{ background: "#000000" }}>
          {banner}
          <AppShellHeader
            title={titleWithToggle}
            centerContent={resolvedHeaderCenter}
            actions={resolvedHeaderActions}
          />
          <Layout.Content
            style={{
              background: "#000000",
              minHeight: "calc(100vh - 56px)",
              overflowX: "hidden",
            }}
          >
            {children}
          </Layout.Content>
        </Layout>
      </Layout>
    </AppShellContext.Provider>
  );
};
